/* ---------------------------------------------------------------
   Cart count in the header.

   The header prints the number only when the cart holds something. This
   keeps the badge in step with the real cart: it appears after the first
   add to cart and hides again when the cart is emptied, without a page
   load.

   Its look (a gold disc on the corner of the bag) lives in cart-count.css.

   It runs after the header markup exists, reads cart.js for the real
   number, and patches the same <span class="cart-count"> the theme
   already styles.
   --------------------------------------------------------------- */
(function () {
  function link() { return document.querySelector('.site-header .cart-link'); }

  function badge() {
    var l = link();
    if (!l) return null;
    var b = l.querySelector('.cart-count');
    if (!b) {
      b = document.createElement('span');
      b.className = 'cart-count';
      b.setAttribute('data-cart-count', '');
      l.appendChild(b);
    }
    return b;
  }

  function paint(n) {
    var b = badge();
    if (!b) return;
    b.textContent = String(n);
    b.classList.toggle('cart-count--zero', n === 0);
    b.setAttribute('aria-hidden', 'true');

    // The link is labelled "Your cart"; add the number so screen readers
    // hear it too, since the badge itself is hidden from them.
    var l = link();
    if (l) {
      var base = l.getAttribute('data-label') || l.getAttribute('aria-label') || '';
      l.setAttribute('data-label', base);
      l.setAttribute('aria-label', n > 0 ? base + ' (' + n + ')' : base);
    }
  }

  function refresh() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) paint(c.item_count); })
      .catch(function () { /* leave whatever the server rendered */ });
  }

  function start() {
    // Show the server-rendered number straight away, or a zero if there
    // was none, so the badge never blinks in from nothing.
    var l = link();
    if (l && !l.querySelector('.cart-count')) paint(0);
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Any successful add, change or clear on the Cart AJAX API repaints it.
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isCartWrite = /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
      return nativeFetch.apply(this, arguments).then(function (res) {
        if (isCartWrite && res.ok) { refresh(); }
        return res;
      });
    };
  }

  // Coming back from the cart or checkout uses the back/forward cache,
  // which skips DOMContentLoaded, so the number would otherwise be stale.
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
